<template>

<div class="mainContainerPerson">
  <h5  tabindex="0">Edit Person Form</h5>
<!--   {{ personId }}
  {{ myPersonEdit }}
  {{ currentNote }} -->

  <div class="formContainerPerson">
    <form @submit="Submit" v-if="this.myPersonEdit">

    <div class="row">

    <div class="col">
      
      <TextInputVue tabindex="0" input-id="loa" label-text="LOA:" :input-v-model="this.myPersonEdit.spotDTSID" object-key="spotDTSID" @update-form="UpdateForm" @blur="v$.myPersonEdit.spotDTSID.$touch" :my-errors="v$.myPersonEdit.spotDTSID.$errors" :disabled="disabled"></TextInputVue>

    </div>

    <div class="col">

      <DropdownInputVue tabindex="0" input-id="campLocationId" label-text="Camp Location:" :input-v-model="this.myPersonEdit.campLocationId" object-key="campLocationId" :option-list="this.campLocationsDropdownValues" @update-form="UpdateForm" @blur="v$.myPersonEdit.campLocationId.$touch" :my-errors="v$.myPersonEdit.campLocationId.$errors"  :disabled="disableCampAndEmployerDropdowns" ></DropdownInputVue>

    </div>

    <div class="col">
      
      <TextInputVue tabindex="0" input-id="usn" label-text="Passport/Taskera/NIN:" :input-v-model="this.myPersonEdit.usn" object-key="usn" @update-form="UpdateForm" @blur="v$.myPersonEdit.usn.$touch" :my-errors="v$.myPersonEdit.usn.$errors" :disabled="disabled"></TextInputVue>

    </div>

  </div>

  <div class="row">

    <div class="col">

      <TextInputVue tabindex="0" input-id="bioGuid" label-text="BioGuid:" :input-v-model="this.myPersonEdit.bioGuid" object-key="bioGuid" @update-form="UpdateForm" :disabled="disabled"></TextInputVue>

    </div>

    

    <div class="col">

      <DropdownInputVue tabindex="0" input-id="companyId" label-text="Employer:" :input-v-model="this.myPersonEdit.companyId" object-key="companyId" :option-list="this.companiesDropdownValues" @update-form="UpdateForm" @blur="v$.myPersonEdit.companyId.$touch" :my-errors="v$.myPersonEdit.companyId.$errors"  :disabled="disableCampAndEmployerDropdowns" ></DropdownInputVue>

    </div>

    <div class="col">

      <RadioBoolInput tabindex="0" input-id="dodCiv" label-text="DoD Civilian:" :input-v-model="this.myPersonEdit.dodCiv" object-key="dodCiv" @update-form="UpdateForm" @blur="v$.myPersonEdit.dodCiv.$touch" :my-errors="v$.myPersonEdit.dodCiv.$errors" :disabled="disabled" bool-true-text="Yes" bool-false-text="No"></RadioBoolInput>

    </div>

  </div>

  <div class="row">

    <div class="col-md-4">
      <label for="deployStartDate" class="form-label">Deploy Start Date (from LOA):</label>
      <input type="date" class="form-control" id="deployStartDate" v-model="myPersonEdit.deployStartDate" >
    </div>

    <div class="col-md-4">
      <label for="deployEndDate" class="form-label">Deploy End Date (from LOA):</label>
      <input type="date" class="form-control" id="deployEndDate" v-model="myPersonEdit.deployEndDate" @blur="v$.myPersonEdit.deployEndDate.$touch" :my-errors="v$.myPersonEdit.deployEndDate.$errors"   >
      <div class="errorMessageForm" v-for="error of v$.myPersonEdit.deployEndDate.$errors" :key="error.$uid">
        {{error.$message}}
      </div>
    </div>

    <div class="col" v-if="myPersonEdit.armingStatusId == 1">

      <DropdownInputVue tabindex="0" input-id="securityType" label-text="Security Type:" :input-v-model="this.myPersonEdit.securityType" object-key="securityType" :option-list="this.securityTypeDropdownValues" @update-form="UpdateForm" @blur="v$.myPersonEdit.securityType.$touch" :my-errors="v$.myPersonEdit.securityType.$errors"  :disabled="disabled" ></DropdownInputVue>
    </div>
  </div>

  <div class="row">

      <div class="col">

          <label for="notesTextarea" id="notesTextarea" class="form-label">Add Notes</label>
          <textarea tabindex="0" class="form-control" v-model="currentNote" rows="8" aria-labelledby="notesTextarea"></textarea>

      </div>

      <div class="col notesContainerContainer">

          <label for="notesColumn" class="form-label">Saved Notes</label>
          <textarea id="notesColumn" class="notesColumnTextarea" :value="myPersonEdit.lrNotes ?? 'No Saved Notes...'" readonly></textarea>
      </div>

      <!--<div class="col notesContainerContainer">

      <label for="notesColumn" class="form-label">Saved Notes</label>
      <div v-if="myPersonEdit.lrNotes != null" class="">

        <div class="notesContainer">
          <div class="notesColumn">{{ myPersonEdit.lrNotes }}</div>
        </div>

      </div>
      <div class="notesColumn" v-else>
        No Saved Notes...
      </div>
    </div>-->

  </div>

  <div class="formButtonContainer">
    <button type="submit" class="btn btn-primary">Save</button>
    <button v-if="myPersonEdit.armingStatusId == 1 || myPersonEdit.armingStatusId == 11" type="submit" class="btn btn-success" @click="Submit($event, 3)">Submit to QC</button>
    <TooltipHelper position="top" tooltip-text="You must Check the QC Verfied setting on each Document for this Person before sending to the QC Complete status..." v-if="myPersonEdit.armingStatusId == 3" custom-slot-id="qcVerifyTooltipSlot">
      <button type="submit" class="btn btn-success" @click="Submit($event, 10)" :disabled="qcCompleteDisabled">QC Complete</button>
    </TooltipHelper>
    
    <button v-if="myPersonEdit.armingStatusId != 11" type="submit" class="btn btn-warning" @click="Submit($event, 11)">Send to Hold</button>
  </div>

    </form>
  </div>
  

  <div class="updateTextContainerContainer" style="position:relative;">
    <div class="updateTextContainer" v-if="updateText != ''">
      {{ updateText }}
    </div>
  </div>
</div>
 
 
</template> 
  
<script> 
  import $ from "jquery";
  import {ajaxGetAndReturn} from "@/components/helpers/utilities.js";
  import { store } from "@/store/store.js";
  import TextInputVue from "@/components/formComponents/TextInput.vue";
  import DropdownInputVue from "@/components/formComponents/DropdownInput.vue";
  import RadioBoolInput from "@/components/formComponents/RadioBoolInput.vue"; 
  import { useVuelidate } from '@vuelidate/core';
  import TooltipHelper from "../dataSupport/TooltipHelper.vue";
  import { 
    required, 
    helpers, 
    minValue,
    requiredIf
  } 
    from '@vuelidate/validators'; 

  export default {
    name: "EditPersonForm",
    components: {
      TextInputVue, DropdownInputVue, RadioBoolInput,TooltipHelper
    }, 
    setup () {
      return { v$: useVuelidate() }
    },
    data(){
      return{
        isMounted : false,
        myPersonEdit:null,
        companiesDropdownValues:null,
        campLocationsDropdownValues:null,
        securityTypeDropdownValues:null,
        currentNote:"",
        updateText:"",
        qcCompleteDisabled:false,
      }
    },
    props: {
      personId:Number,
    },
    created(){ // called BEFORE rendering (load data here)
      ajaxGetAndReturn(store.webAPIUrl + "people/GetContractPersonEdit/" + this.personId, (result) =>{
        this.myPersonEdit = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "companies/getDropdown", (result) =>{
          this.companiesDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "campLocations/getDropdown", (result) =>{
          this.campLocationsDropdownValues = result; 
      });
      ajaxGetAndReturn(store.webAPIUrl + "securityTypes/getDropdown", (result) =>{
          this.securityTypeDropdownValues = result; 
      });

      /*
      ajaxGetAndReturn(store.webAPIUrl + "personDocument/GetQcDocumentStatusByPerson/" + this.personId, (result) =>{
          this.qcCompleteDisabled = !result;
      });
      */
    },
    mounted() { // called afer rendering
      this.isMounted = true; 

    },
    computed:{
      disableCampAndEmployerDropdowns(){
        if(this.myPersonEdit.armingStatusId != 1){
          return true; 
        }
        return false;
      },
      
    },

    methods:{
      async Submit(e, statusChange){
        e.preventDefault(); 
        console.log("submitting form");
        console.log(this.v$.$errors);
        const isFormCorrect = await this.v$.$validate();
        // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
        if (!isFormCorrect) return;

        
        if(this.currentNote != ""){
          var date = new Date();
          var todaysDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear();
          var thisNote = todaysDate + ": " + this.currentNote + "\n"; 

          if(this.myPersonEdit.lrNotes == undefined) this.myPersonEdit.lrNotes = '';
          var notesRaw = thisNote + this.myPersonEdit.lrNotes; 
          this.myPersonEdit.lrNotes = notesRaw;
        }

        if(statusChange != null){
          this.myPersonEdit.armingStatusId = statusChange;
        }

        $.ajax({
            method: "PUT",
            data: JSON.stringify(this.myPersonEdit),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            url: store.webAPIUrl + "People/putPersonDto/" + this.personId,
            success: (result) => {
                result;
                //var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                //console.log(successMessage);
                ajaxGetAndReturn(store.webAPIUrl + "people/GetContractPersonEdit/" + this.personId, (result) =>{
                  this.myPersonEdit = result; 
                  this.updateText = "Successfully update Record in DB on " + new Date(); 
                  //allow the user ~half a second to hover over the element before the tooltip appears.
                  this.currentNote = '';
                  this.timer = setTimeout(() => {
                      this.updateText = ''; 
                     
                  }, 1500);
                });
            },
        });
      },
      UpdateForm(objKey, modelData){
        //console.log("dropdowkksajdlfk")
        this.myPersonEdit[objKey] = modelData;
      },

    },
    unmounted(){ //called when the page is left or the component is destroyed

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    },
    validations () {
      return {
        myPersonEdit:{
              spotDTSID: {
                  required:helpers.withMessage("LOA is Required", required)
              },
              campLocationId: {
                    minValue: helpers.withMessage("Camp Location is Required", minValue(1))
              },
              usn: {
                  required:helpers.withMessage("Passport/Taskera/NIN is Required", required)
              },
              dodCiv: {
                  required:helpers.withMessage("Must select DoD Civilian status (Y/N)", required)
              },
              companyId: {
                    minValue: helpers.withMessage("Employer Name is Required", minValue(1))
              },
              securityType:{
                required:requiredIf(function(){
                  if(this.myPersonEdit.armingStatusId == 1) return true;
                  return false;
                }), 
                minValue:helpers.withMessage("Security Type is Required for people in the New status.", minValue(1))
              },
              deployEndDate:{
                minValue: helpers.withMessage("Deploy End Date Must be AFTER deploy start date.", value => {
                  return new Date(value) > new Date(this.myPersonEdit.deployStartDate); 
                } )
              }
            },
          }
      }
  }
</script>
  
<style scoped>
.formButtonContainer{
  margin-top:15px;
}
.notesContainerContainer{
  display:flex;
  flex-direction:column;
}
.notesColumn{
  display: flex;
    flex-direction: column;
    text-align: left;
    height: 206px;
    /*overflow-y: scroll;*/
    overflow: auto;
    padding:8px;
    border:1px solid lightgray;
    border-radius:3px; 
    background-color:#f2f2f2;
    white-space:pre-wrap;
}

    .notesColumnTextarea {
        height: 206px;
        overflow-y: scroll;
        padding: 8px;
        border: 1px solid lightgray;
        border-radius: 3px;
        background-color: #f2f2f2;
        white-space: pre-wrap;
        width: 100%;
        resize: none;
    }

.updateTextContainer{
  display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    background: lightblue;
    width: 504px;
    margin-top: 5px;
    border-radius: 3px;
    padding: 4px;
    font-size: 13px;
    font-weight: bolder;
    color: green;
    position: absolute;
    top: -76px;
    left: 14px;
}
    .mainContainerPerson {
        width: 85%;
        margin-left: auto;
        margin-right: auto;
        background-color: #228B22;
        /*background: lightgreen;*/
        /* padding: 15px; */
        border-radius: 5px;
        margin-top: 15px;
        padding-bottom: 2px;
        margin-bottom: 10px;
    }
        .mainContainerPerson h5 {
            /*background: #339933;*/
            background-color: #008000;
            padding-bottom: 15px;
            padding-top: 15px;
            border-radius: 5px 5px 0px 0px;
            color: white;
        }
.formContainerPerson{
    padding: 5px;
    margin: 5px;
    background: #ecf9ec;
    margin-bottom: 15px;
    padding-bottom: 15px;
}
.btn-warning{
  margin-left:10px;
}

#qcVerifyTooltipSlot{
  display: inline;
}
</style>
